var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-steps"},[_vm._l((_vm.steps),function(step,index){return _c('span',{key:index,class:{ active: index === _vm.activeStep }},[_vm._v(_vm._s(index + 1))])}),_c('p',[_vm._v(_vm._s(_vm.steps[_vm.activeStep].step))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }